import { ProductListConfig } from 'rangeConfig/@types';
import {
  matchExistingSectionWidths,
  requiresSelectedColour
} from 'rangeConfig/boaxel/filters/mainMenuProductFilters';
import { sortInteriorClustersByPreferredTypeOrder } from 'rangeConfig/boaxel/sorting/sort';
import addInterior from 'rangeConfig/boaxel/behaviors/addInterior';

const interiorsProductListConfig: ProductListConfig = {
  cluster: ['type', 'design'],
  cardsSubtitle: 'typeName, designText',
  behaviors: {
    productClicked: [addInterior],
    productDropped: [addInterior]
  },
  infoButtonAriaLabel: 'storageone.productListInteriorsTitle',
  sortOrder: [],
  sortClusteredProducts: sortInteriorClustersByPreferredTypeOrder,
  categories: [
    {
      id: 'interiors-shelves',
      products: []
    }
  ],
  productFilters: [requiresSelectedColour, matchExistingSectionWidths]
};

export default interiorsProductListConfig;
